import { SetupPasswordPage } from "@/features/auth/pages/AccountRecoveryPages";
import {
	PORTAL_PATH,
	isAccountRecoveryAvailable,
} from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

type SetupPasswordSearch = { token: string };

export const Route = createFileRoute("/vendor/buat-kata-sandi")({
	beforeLoad: () => {
		if (!isAccountRecoveryAvailable) throw redirect({ to: PORTAL_PATH.Login });
	},
	validateSearch: (search: Record<string, unknown>): SetupPasswordSearch => ({
		token: typeof search.token === "string" ? search.token : "",
	}),
	component: SetupPasswordRoute,
});

function SetupPasswordRoute() {
	const { token } = Route.useSearch();
	return <SetupPasswordPage token={token} />;
}
